<div *ngIf="show" id="main-body-content" class='container page-loggedOut' ng-cloak>
  <div id="SHpageHeader"></div>
  <div id="SHlogo"></div>
  <div id="SHcontentContainer">
    <div id="SHpageTextContainer">
      <h2>You are already logged out.</h2>
      <br />
      <h5><a style="text-decoration:underline;" href="https://www.tql.com">Click here</a> to return to tql.com.</h5>
    </div>
    <div id="SHimg"></div>
  </div>
</div>